import { forwardRef, useImperativeHandle, useRef } from 'react';
import { motion, useAnimationControls } from 'framer-motion';

const ShakeWrapper = forwardRef(function ShakeWrapper({ children, className }, ref) {
  const controls = useAnimationControls();

  useImperativeHandle(ref, () => ({
    shake: () =>
      controls.start({
        x: [-8, 8, -8, 8, 0],
        transition: { duration: 0.4 },
      }),
  }));

  return (
    <motion.div animate={controls} className={className}>
      {children}
    </motion.div>
  );
});

export default ShakeWrapper;
